export default __webpack_public_path__ + "static/media/hero9.ad2bdcdf.png";